// extracted by mini-css-extract-plugin
export default {"debug-panel":"DebugPanel_debug-panel__0pKlO","expanded":"DebugPanel_expanded__s3tzR","debug-panel-icon":"DebugPanel_debug-panel-icon__jAG37"};